import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import './index.css';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Backups from './pages/Backups';
import System from './pages/System';
import Docker from './pages/Docker';
import DockerLogs from './pages/DockerLogs';
import Traefik from './pages/Traefik';
import ServersManager from './pages/ServersManager';
import Users from './pages/Users';
import BackupConfig from './pages/BackupConfig';
import BackupLogs from './pages/BackupLogs';
import GlobalConfig from './pages/GlobalConfig';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { ServerProvider } from './contexts/ServerContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutos
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <ServerProvider>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/backups" element={<Backups />} />
                        <Route path="/system" element={<System />} />
                        <Route path="/docker" element={<Docker />} />
                        <Route path="/docker-logs" element={<DockerLogs />} />
                        <Route path="/traefik" element={<Traefik />} />
                        <Route path="/servers" element={<ServersManager />} />
                        <Route path="/users" element={<Users />} />
                        <Route path="/backup-config" element={<BackupConfig />} />
                        <Route path="/backup-logs" element={<BackupLogs />} />
                        <Route path="/global-config" element={<GlobalConfig />} />
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                      </Routes>
                    </Layout>
                  </ServerProvider>
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;